(() => {
  'use strict';

  const DISCOUNT_CODES = {
    // Coduri ACTIVE in Shopify (aprobate George 2026-08-21), scopate pe colectia
    // multi-builder-pungi-intern cu prag minim de cantitate 5/10/20.
    // Redirectul /discount/<cod>?redirect=/checkout aplica automat tierul cel mai mare atins;
    // un cod dezactivat nu blocheaza checkoutul (flow degradeaza la pret intreg).
    5: 'PACHET5',
    10: 'PACHET10',
    20: 'PACHET20'
  };

  function parseJson(id) {
    const el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (error) { console.error('[cj-mb] JSON parse failed', id, error); return null; }
  }

  function fmtPrice(value) {
    return Number(value || 0).toFixed(2).replace('.', ',') + ' lei';
  }

  function animateValue(el, from, to, duration) {
    if (!el) return;
    if (from === to) {
      el.textContent = fmtPrice(to);
      return;
    }
    let start = null;
    const diff = to - from;
    function step(ts) {
      if (!start) start = ts;
      const progress = Math.min((ts - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = fmtPrice(from + diff * eased);
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function tasteScale(product) {
    const d = product.taste;
    if (!d) return '';
    function dots(n) {
      return new Array(5).fill(0).map(function(_, i) {
        return '<span style="display:inline-block;width:9px;height:9px;border-radius:50%;margin-left:3px;background:' + (i < n ? '#7A1F1F' : '#E0D6CC') + ';"></span>';
      }).join('');
    }
    function row(label, n) {
      return '<div style="display:flex;align-items:center;justify-content:space-between;margin:3px 0;"><span>' + label + '</span><span style="white-space:nowrap;">' + dots(n) + '</span></div>';
    }
    return '<div class="mb-product__taste" style="padding:2px 14px 6px;font-size:11px;color:#5b5048;line-height:1.2;overflow-wrap:anywhere;word-break:break-word;min-width:0;">'
      + row('Aromă', d.carne)
      + row('Sărat', d.sarat)
      + row('Condimentat', d.condimentat)
      + '<div style="margin-top:5px;"><div style="display:flex;justify-content:space-between;font-size:10px;color:#8a8078;margin-bottom:3px;"><span>Moale</span><span>Crocant</span></div><div style="position:relative;height:6px;border-radius:3px;background:linear-gradient(90deg,#E8D9C5,#7A1F1F);"><div style="position:absolute;top:-2px;left:calc(' + d.textura + '% - 5px);width:10px;height:10px;border-radius:50%;background:#fff;border:2px solid #7A1F1F;box-shadow:0 1px 2px rgba(0,0,0,.2);"></div></div></div></div>';
  }

  function resolveProductMap(sectionId) {
    const inlineMap = parseJson('cj-mb-product-map-' + sectionId);
    if (inlineMap && typeof inlineMap === 'object') return inlineMap;
    if (window.CJ_MB_PRODUCT_MAP && typeof window.CJ_MB_PRODUCT_MAP === 'object') return window.CJ_MB_PRODUCT_MAP;
    return {};
  }

  function getDiscountRedirect(qty, checkoutUrl) {
    if (qty >= 20) return '/discount/' + encodeURIComponent(DISCOUNT_CODES[20]) + '?redirect=' + encodeURIComponent(checkoutUrl || '/checkout');
    if (qty >= 10) return '/discount/' + encodeURIComponent(DISCOUNT_CODES[10]) + '?redirect=' + encodeURIComponent(checkoutUrl || '/checkout');
    if (qty >= 5) return '/discount/' + encodeURIComponent(DISCOUNT_CODES[5]) + '?redirect=' + encodeURIComponent(checkoutUrl || '/checkout');
    return checkoutUrl || '/checkout';
  }

  function init(root) {
    const sectionId = root.dataset.sectionId;
    const config = parseJson('cj-mb-config-' + sectionId);
    const products = parseJson('cj-mb-products-' + sectionId) || [];
    const presets = parseJson('cj-mb-presets-' + sectionId) || {};
    if (!config || !products.length) return;

    const productMap = resolveProductMap(sectionId);
    const state = {};
    products.forEach(function(product) { state[product.sku] = 0; });
    const maxQty = Number(config.maxQty || 20);
    const celebratedTiers = new Set([5]);
    const productsGrid = root.querySelector('[data-products-grid]');
    const cart = root.querySelector('[data-cart]');
    const cartItems = root.querySelector('[data-cart-items]');
    const recapItems = root.querySelector('[data-recap-items]');
    const tierCards = Array.from(root.querySelectorAll('.mb-tier-card'));
    const presetButtons = Array.from(root.querySelectorAll('.mb-preset'));
    const checkoutButtons = Array.from(root.querySelectorAll('[data-checkout]'));
    const submitError = root.querySelector('[data-submit-error]');
    const tierFill = root.querySelector('[data-tier-fill]');
    const tierLabel = root.querySelector('[data-tier-label]');
    const stickyBar = root.querySelector('[data-sticky-bar]');
    const stickyQty = root.querySelector('[data-sticky-qty]');
    const stickyBadge = root.querySelector('[data-sticky-badge]');
    const stickyTotal = root.querySelector('[data-sticky-total]');
    const stickyCta = root.querySelector('[data-sticky-cta]');
    const nativeCheckout = root.querySelector('[data-native-checkout]');
    const builderSection = root.querySelector('.mb-builder-section');
    const heroSection = root.querySelector('.mb-hero');
    const toastEl = root.querySelector('[data-toast]');
    const progressSteps = Array.from(root.querySelectorAll('.mb-progress__step'));
    const progressLines = Array.from(root.querySelectorAll('[data-progress-line]'));
    const ui = {
      subtotal: root.querySelector('[data-subtotal]'),
      discountRow: root.querySelector('[data-discount-row]'),
      discountPct: root.querySelector('[data-discount-pct]'),
      discountAmount: root.querySelector('[data-discount-amount]'),
      shipping: root.querySelector('[data-shipping]'),
      total: root.querySelector('[data-total]'),
      savings: root.querySelector('[data-savings]'),
      savingsAmount: root.querySelector('[data-savings-amount]'),
      checkoutSubtotal: root.querySelector('[data-checkout-subtotal]'),
      checkoutDiscountRow: root.querySelector('[data-checkout-discount-row]'),
      checkoutDiscount: root.querySelector('[data-checkout-discount]'),
      checkoutShipping: root.querySelector('[data-checkout-shipping]'),
      checkoutTotal: root.querySelector('[data-checkout-total]'),
      recapSubtotal: root.querySelector('[data-recap-subtotal]'),
      recapDiscountRow: root.querySelector('[data-recap-discount-row]'),
      recapDiscount: root.querySelector('[data-recap-discount]'),
      recapShipping: root.querySelector('[data-recap-shipping]'),
      recapTotal: root.querySelector('[data-recap-total]')
    };
    let prevCartSub = 0;
    let prevCartTotal = 0;
    let prevStickyTotal = 0;
    let prevStickyTier = 0;
    let pastHero = false;
    let reachedCheckout = false;

    productsGrid.innerHTML = products.map(function(product, index) {
      const badges = (product.badges || []).map(function(badge, i) {
        const style = product.badge_styles && product.badge_styles[i] ? ' style="' + product.badge_styles[i] + '"' : '';
        return '<span class="mb-badge"' + style + '>' + badge + '</span>';
      }).join('');
      return '<div class="mb-product" data-sku="' + product.sku + '" data-price="' + product.price_ron + '" style="animation-delay:' + (index * 0.04) + 's">'
        + '<div class="mb-product__img"><img src="' + product.image + '" alt="' + product.name + '"></div>'
        + '<div class="mb-product__info"><h3>' + product.name + '</h3><span class="mb-product__macros">' + product.weight + ' · ' + product.protein + '</span><span class="mb-product__unit-price">' + fmtPrice(product.price_ron).replace(' lei', '') + ' lei / pungă</span></div>'
        + tasteScale(product)
        + '<div class="mb-product__stepper"><button class="mb-stepper__btn mb-stepper__minus" type="button" data-action="minus" data-sku="' + product.sku + '" disabled>−</button><span class="mb-stepper__qty" data-qty-display="' + product.sku + '">0</span><button class="mb-stepper__btn mb-stepper__plus" type="button" data-action="plus" data-sku="' + product.sku + '">+</button></div>'
        + '<div class="mb-product__badges">' + badges + '</div>'
        + '<div class="mb-product__feedback"><span class="mb-product__subtotal-val"></span><span class="mb-product__tier-badge"></span></div>'
        + '</div>';
    }).join('');

    function setProgressStep(step) {
      progressSteps.forEach(function(node) {
        const n = Number(node.dataset.navStep);
        node.classList.remove('is-current', 'is-done');
        if (n < step) node.classList.add('is-done');
        if (n === step) node.classList.add('is-current');
      });
      progressLines.forEach(function(line, index) { line.classList.toggle('is-filled', step > index + 1); });
    }

    function getTotalQty() {
      return Object.values(state).reduce(function(sum, value) { return sum + value; }, 0);
    }

    function getSubtotal() {
      return products.reduce(function(sum, product) { return sum + (state[product.sku] * Number(product.price_ron)); }, 0);
    }

    function getTier(qty) {
      if (qty >= 20) return { pct: 30, frac: 0.30, progress: 100, status: '−30% aplicat! Reducere maximă!' };
      if (qty >= 10) return { pct: 15, frac: 0.15, progress: 66, status: '−15% aplicat! Încă ' + (20 - qty) + ' pungi pentru −30%' };
      if (qty >= 5) return { pct: 10, frac: 0.10, progress: 33, status: '−10% aplicat! Încă ' + (10 - qty) + ' pungi pentru −15%' };
      if (qty > 0) return { pct: 0, frac: 0, progress: (qty / 5) * 25, status: 'Încă ' + (5 - qty) + ' pungi pentru −10%' };
      return { pct: 0, frac: 0, progress: 0, status: 'Adaugă 5 pungi pentru prima reducere' };
    }

    function selectedItems() {
      return products.filter(function(product) { return state[product.sku] > 0; }).map(function(product) {
        return Object.assign({}, product, { quantity: state[product.sku], map: productMap[product.map_key] || null });
      });
    }

    function showToast(message) {
      if (!toastEl) return;
      toastEl.textContent = message;
      toastEl.classList.add('is-show');
      setTimeout(function() { toastEl.classList.remove('is-show'); }, 2500);
    }

    function fireConfetti() {
      const container = document.createElement('div');
      container.className = 'mb-confetti-container';
      const colors = ['#C9A961', '#7A1F1F', '#D4A853', '#4A5D3A', '#F5EDE0', '#E8C170'];
      for (let i = 0; i < 30; i += 1) {
        const particle = document.createElement('div');
        particle.className = 'mb-confetti';
        particle.style.left = (Math.random() * 100) + '%';
        particle.style.top = '-10px';
        particle.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
        particle.style.animationDelay = (Math.random() * 0.6) + 's';
        particle.style.animationDuration = (1.5 + Math.random()) + 's';
        particle.style.width = (5 + Math.random() * 6) + 'px';
        particle.style.height = particle.style.width;
        container.appendChild(particle);
      }
      document.body.appendChild(container);
      setTimeout(function() { container.remove(); }, 3000);
    }

    function updateStickyBar(qty) {
      const shouldShow = qty >= 1 && pastHero && !reachedCheckout && window.innerWidth < 768;
      if (stickyBar) stickyBar.classList.toggle('is-visible', shouldShow);
    }

    function renderCart(items, tier) {
      if (!items.length) {
        cartItems.innerHTML = '<div class="mb-cart__empty"><b>Pachetul tău e gol</b><span>Începe cu Vită Original — cel mai ales sortiment</span><button class="mb-empty-cta" type="button" data-add-sku="beef">Adaugă Vită Original</button><span>Adaugă 5+ pungi pentru reducere automată −10%</span></div>';
        recapItems.innerHTML = '<div class="mb-recap__empty">Alege produse din builder.</div>';
      } else {
        cartItems.innerHTML = items.map(function(item, index) {
          return '<div class="mb-cart__item" style="animation-delay:' + (index * 50) + 'ms"><img src="' + item.image + '" alt="' + item.name + '"><div class="mb-cart__item-info"><b>' + item.name + '</b><span class="mb-cart__item-meta">' + item.quantity + ' × ' + item.weight + '</span><span class="mb-cart__item-price">' + fmtPrice(item.price_ron) + '/buc</span></div><span class="mb-cart__item-total">' + fmtPrice(item.quantity * item.price_ron) + '</span></div>';
        }).join('');
        recapItems.innerHTML = items.map(function(item) {
          return '<div class="mb-recap__item"><img src="' + item.image + '" alt=""><div class="mb-recap__item-name"><b>' + item.name + ' × ' + item.quantity + '</b><span>' + item.weight + '</span><span>' + fmtPrice(item.price_ron) + ' / buc</span></div><span>' + fmtPrice(item.quantity * item.price_ron) + '</span></div>';
        }).join('');
      }
      products.forEach(function(product) {
        const row = productsGrid.querySelector('[data-sku="' + product.sku + '"]');
        if (!row) return;
        row.classList.toggle('has-qty', state[product.sku] > 0);
        const subtotalNode = row.querySelector('.mb-product__subtotal-val');
        const unitPriceNode = row.querySelector('.mb-product__unit-price');
        const badgeNode = row.querySelector('.mb-product__tier-badge');
        const minus = row.querySelector('[data-action="minus"]');
        const qtyNode = row.querySelector('[data-qty-display="' + product.sku + '"]');
        const qty = state[product.sku];
        const discountedUnit = Number((product.price_ron * (1 - tier.frac)).toFixed(2));
        qtyNode.textContent = String(qty);
        minus.disabled = qty === 0;
        if (qty > 0) {
          subtotalNode.textContent = fmtPrice(qty * (tier.frac > 0 ? discountedUnit : product.price_ron));
          badgeNode.textContent = tier.pct > 0 ? '✓ Contribuie la −' + tier.pct + '%' : '';
          if (tier.frac > 0) {
            unitPriceNode.innerHTML = '<s style="opacity:0.5;font-size:0.85em;margin-right:3px;">' + fmtPrice(product.price_ron).replace(' lei', '') + '</s> ' + fmtPrice(discountedUnit).replace(' lei', '') + ' lei / pungă';
          } else {
            unitPriceNode.textContent = fmtPrice(product.price_ron).replace(' lei', '') + ' lei / pungă';
          }
        } else {
          subtotalNode.textContent = '';
          badgeNode.textContent = '';
          unitPriceNode.textContent = fmtPrice(product.price_ron).replace(' lei', '') + ' lei / pungă';
        }
      });
    }

    function recompute() {
      const qty = getTotalQty();
      const subtotal = Number(getSubtotal().toFixed(2));
      const tier = getTier(qty);
      const discount = Number((subtotal * tier.frac).toFixed(2));
      const afterDiscount = Number((subtotal - discount).toFixed(2));
      const shipping = qty === 0 ? null : (afterDiscount >= Number(config.freeShippingThreshold) ? 0 : Number(config.shipCost));
      const total = qty === 0 ? 0 : Number((afterDiscount + shipping).toFixed(2));
      const savings = Number((discount + (shipping === 0 && qty > 0 ? Number(config.shipCost) : 0)).toFixed(2));
      const items = selectedItems();

      tierCards.forEach(function(card) {
        const target = Number(card.dataset.tier);
        card.classList.remove('is-active', 'is-passed');
        if (qty >= target) {
          if ((target === 5 && qty < 10) || (target === 10 && qty < 20) || (target === 20 && qty >= 20)) card.classList.add('is-active');
          if ((target === 5 && qty >= 10) || (target === 10 && qty >= 20)) card.classList.add('is-passed');
        }
      });
      tierFill.style.width = tier.progress + '%';
      tierLabel.textContent = tier.status;
      cart.classList.toggle('is-empty', qty === 0);
      renderCart(items, tier);

      animateValue(ui.subtotal, prevCartSub, subtotal, 300);
      prevCartSub = subtotal;
      if (discount > 0) {
        ui.discountRow.hidden = false;
        ui.discountPct.textContent = String(tier.pct);
        ui.discountAmount.textContent = '−' + fmtPrice(discount);
      } else {
        ui.discountRow.hidden = true;
      }
      ui.shipping.textContent = shipping === null ? '—' : (shipping === 0 ? 'GRATIS' : fmtPrice(shipping));
      animateValue(ui.total, prevCartTotal, total, 300);
      prevCartTotal = total;
      ui.savings.hidden = savings <= 0;
      ui.savingsAmount.textContent = fmtPrice(savings);
      ui.checkoutSubtotal.textContent = fmtPrice(subtotal);
      ui.checkoutDiscountRow.hidden = discount <= 0;
      ui.checkoutDiscount.textContent = '−' + fmtPrice(discount);
      ui.checkoutShipping.textContent = shipping === null ? '—' : (shipping === 0 ? 'GRATIS' : fmtPrice(shipping));
      ui.checkoutTotal.textContent = fmtPrice(total);
      ui.recapSubtotal.textContent = fmtPrice(subtotal);
      ui.recapDiscountRow.hidden = discount <= 0;
      ui.recapDiscount.textContent = '−' + fmtPrice(discount);
      ui.recapShipping.textContent = shipping === null ? '—' : (shipping === 0 ? 'GRATIS' : fmtPrice(shipping));
      ui.recapTotal.textContent = fmtPrice(total);

      stickyQty.textContent = String(qty);
      animateValue(stickyTotal, prevStickyTotal, total, 300);
      prevStickyTotal = total;
      if (tier.pct > 0) {
        stickyBadge.hidden = false;
        stickyBadge.innerHTML = '−' + tier.pct + '%';
        if (tier.pct !== prevStickyTier) {
          stickyBadge.classList.remove('pulse');
          void stickyBadge.offsetWidth;
          stickyBadge.classList.add('pulse');
        }
      } else {
        stickyBadge.hidden = true;
      }
      prevStickyTier = tier.pct;
      checkoutButtons.forEach(function(button) {
        button.disabled = qty === 0;
        button.classList.toggle('opacity-50', qty === 0);
        button.classList.toggle('pointer-events-none', qty === 0);
        if (!button.dataset.defaultLabel) button.dataset.defaultLabel = button.textContent;
        if (qty === 0) button.textContent = button.dataset.defaultLabel;
      });
      updateStickyBar(qty);
      setProgressStep(qty > 0 ? 2 : 1);

      [{threshold:5,msg:'−10% activat!',confetti:false},{threshold:10,msg:'−15% activat!',confetti:true},{threshold:20,msg:'−30% activat! Reducere maximă!',confetti:true}].forEach(function(entry) {
        if (qty >= entry.threshold && !celebratedTiers.has(entry.threshold)) {
          celebratedTiers.add(entry.threshold);
          const card = tierCards.find(function(node) { return Number(node.dataset.tier) === entry.threshold; });
          if (card) {
            card.classList.remove('celebrate');
            void card.offsetWidth;
            card.classList.add('celebrate');
          }
          showToast(entry.msg);
          if (entry.confetti) fireConfetti();
        }
      });
    }

    productsGrid.addEventListener('click', function(event) {
      const button = event.target.closest('[data-action]');
      if (!button) return;
      const sku = button.dataset.sku;
      if (!(sku in state)) return;
      if (button.dataset.action === 'plus' && state[sku] < maxQty) state[sku] += 1;
      if (button.dataset.action === 'minus' && state[sku] > 0) state[sku] -= 1;
      recompute();
      const qtyNode = productsGrid.querySelector('[data-qty-display="' + sku + '"]');
      if (qtyNode) {
        qtyNode.classList.remove('pulse');
        void qtyNode.offsetWidth;
        qtyNode.classList.add('pulse');
      }
    });

    root.addEventListener('click', function(event) {
      const addBtn = event.target.closest('[data-add-sku]');
      if (addBtn) {
        const sku = addBtn.dataset.addSku;
        if (sku in state && state[sku] < maxQty) {
          state[sku] += 1;
          recompute();
        }
        return;
      }
      const preset = event.target.closest('[data-preset]');
      if (preset) {
        const next = presets[preset.dataset.preset];
        if (next && next.state) {
          Object.keys(state).forEach(function(sku) { state[sku] = 0; });
          Object.keys(next.state).forEach(function(sku) { if (sku in state) state[sku] = next.state[sku]; });
          presetButtons.forEach(function(button) { button.classList.toggle('is-active', button === preset); });
          recompute();
          if (builderSection) builderSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        return;
      }
      const tierCard = event.target.closest('.mb-tier-card');
      if (tierCard) {
        const tier = Number(tierCard.dataset.tier);
        const key = tier === 5 ? 'starter' : (tier === 10 ? 'bestseller' : 'family');
        const next = presets[key];
        if (next && next.state) {
          Object.keys(state).forEach(function(sku) { state[sku] = 0; });
          Object.keys(next.state).forEach(function(sku) { if (sku in state) state[sku] = next.state[sku]; });
          recompute();
        }
      }
    });

    async function addToCartAndCheckout() {
      const items = selectedItems();
      if (!items.length) return;
      const missing = items.filter(function(item) { return !(item.map && item.map.variant_id); });
      if (missing.length) {
        submitError.textContent = 'Lipsește variant_id în maparea inline din secțiune pentru: ' + missing.map(function(item) { return item.map_key; }).join(', ');
        submitError.classList.add('is-visible');
        return;
      }
      submitError.classList.remove('is-visible');
      submitError.textContent = '';
      checkoutButtons.forEach(function(button) {
        button.disabled = true;
        button.textContent = 'Se procesează…';
      });
      try {
        const payload = { items: items.map(function(item) { return { id: Number(item.map.variant_id), quantity: item.quantity }; }) };
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        });
        if (!response.ok) {
          const data = await response.json().catch(function() { return {}; });
          throw new Error(data.description || data.message || 'Shopify cart/add.js a eșuat.');
        }
        setProgressStep(3);
        window.location.assign(getDiscountRedirect(getTotalQty(), config.checkoutUrl));
      } catch (error) {
        submitError.textContent = error.message;
        submitError.classList.add('is-visible');
        checkoutButtons.forEach(function(button) {
          button.disabled = false;
          button.textContent = button.dataset.defaultLabel || 'Adaugă în coș și mergi la checkout';
        });
      }
    }

    checkoutButtons.forEach(function(button) { button.addEventListener('click', addToCartAndCheckout); });
    if (stickyCta && nativeCheckout) stickyCta.addEventListener('click', function() { nativeCheckout.scrollIntoView({ behavior: 'smooth', block: 'start' }); });

    const revealObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        if (entry.target.classList.contains('mb-rating-breakdown')) {
          entry.target.querySelectorAll('.mb-rating__bar-fill').forEach(function(bar) { bar.style.width = bar.dataset.width + '%'; });
        }
        revealObs.unobserve(entry.target);
      });
    }, { threshold: 0.15 });
    root.querySelectorAll('.mb-reveal, .mb-rating-breakdown').forEach(function(node) { revealObs.observe(node); });

    if (heroSection) {
      const heroObs = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          pastHero = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          updateStickyBar(getTotalQty());
        });
      }, { threshold: 0 });
      heroObs.observe(heroSection);
    }
    if (nativeCheckout) {
      const checkoutObs = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          reachedCheckout = entry.isIntersecting;
          if (entry.isIntersecting) setProgressStep(3);
          updateStickyBar(getTotalQty());
        });
      }, { threshold: 0.15 });
      checkoutObs.observe(nativeCheckout);
    }

    window.addEventListener('scroll', function() {
      const nav = root.querySelector('.mb-nav');
      if (nav) nav.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });

    if (presets.starter && presets.starter.state) {
      Object.keys(presets.starter.state).forEach(function(sku) { if (sku in state) state[sku] = presets.starter.state[sku]; });
    }
    presetButtons.forEach(function(button) { button.classList.toggle('is-active', button.dataset.preset === 'starter'); });
    recompute();
  }

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.cj-mb[data-section-id]').forEach(function(root) { init(root); });
  });
})();
